const translation = {
  tab2020: '2020 year',
  tab2021: '2021 year',
  title: "Year-end Settlement Usage Guide",
  subText: "Check out the features of WEHAGO’s year-end tax settlement service!",
  download: "Download year-end adjustment manual",
  enquiryRegistrationAlert:
    "A year-end adjustment inquiry has been registered.",
  checkInfo1: "Please check the contact information.",
  replyEmail: "We will respond promptly with an email address.",
  validationError: "Contact or email address is not in the correct format.",
  checkInfo2: "Please check the information and try again.",
  ok: "OK",
  provideLater: "We plan to provide it later.",
  author: "Author",
  enterName: "Please enter your first and last name.",
  companyName: "Company name",
  enterCompanyName: "Please enter your company name.",
  contacts: "Contacts",
  enterContacts: "Please enter your contact information ('-'Exclude)",
  email: "E-mail",
  enterEmail: "Please enter your email address.",
  enquiryRegistration: "WEHAGO year-end adjustment inquiry registration",
  enquirySubText:
    "Please write any questions you have about the year-end tax settlement service.",
  InquirerInfo: "Contact Information",
  InquirerContent: "Inquiries",
  enterContent: "Enter the details.",
  consentText: `In accordance with the Act on Promotion of Information and Communications Network Utilization and Information Protection, etc., we would like to collect and use personal information as follows to handle inquiries about year-end settlement service, so please agree. <br/> <br/>
                Collected items: Name, company, mobile phone, email address <br/> 
                Purpose of collection: Answers and Answers to your questions <br/> 
                Storage period: Discard after storage for up to 3 years from the date of inquiry registration `,
  registration: "Registration",
  fullView: "Full view",
  folding: "origami paper",
  postDate: "Posting date",
  hitCount: "Hit count",
  faq: "FAQ",
  inquiryRegistration1: "Enquiry Registration",
  inquiryRegistration2: "Enquiry Registration",
  subTitle: "WEHAGO year-end adjustment",

  usePersonalInfo: "Agree to collect and use personal information",
  essential: "(Necessity)",

  contentsPreparingTitle: "콘텐츠 준비중입니다.",
  contentsPreparingMessage: "빠른 시일내에 오픈하겠습니다.",
};

export { translation };
